export interface IInformationMandate {
    date_accepted: number;
    id_nr: string;
    insurers: Array<string>;
}
  